import type { ConcreteComponent, ComponentInternalInstance } from 'vue'

type ConcreteComponentWithScopeId = ConcreteComponent & {
  __scopeId: string | undefined
}

function getParentId(
  instance: ComponentInternalInstance | null,
  id: string[]
): string[] {
  const instanceId = (instance?.type as ConcreteComponentWithScopeId)?.__scopeId

  if (instance?.parent) {
    const parentsId = getParentId(instance.parent, id)

    return instanceId
      ? [...id, instanceId, ...parentsId]
      : [...id, ...parentsId]
  }

  return instanceId ? [...id, instanceId] : id
}

/**
 * 取得祖先元件的 Scoped CSS attribute，
 * 用於 Teleport 將 DOM 移至父層外時，手動套用 scoped 樣式。
 */
export function useScopeId() {
  /** 祖先元件的 Scoped CSS ID 陣列 */
  const parentsScopedId = ref<string[]>([])

  /** 祖先元件 Scoped ID 轉為 attribute 物件（供 v-bind） */
  const parentsScopedIdAttribute = computed((): Record<string, boolean> => {
    return parentsScopedId.value.reduce(
      (pre, cur) => {
        pre[cur] = true

        return pre
      },
      {} as Record<string, boolean>
    )
  })

  onMounted(() => {
    parentsScopedId.value = getParentId(getCurrentInstance(), [])
  })

  return {
    /** 祖先元件 Scoped ID 轉為 attribute 物件（供 v-bind） */
    parentsScopedIdAttribute,
    /** 祖先元件的 Scoped CSS ID 陣列 */
    parentsScopedId
  }
}
